<template>
    <div>
        <Breadcrumbs main="Services" title="Save As You Spend"/>
        <!-- <div v-if="routeName === 'save-as-you-spend'">
          <comingSoon/>
        </div> -->
        <!-- Container-fluid starts-->
        <div v-if="loading" class="loader-12"></div>
        <div v-else class="container-fluid">
            <section class="header-section">
              <div class="row align-items-center">
                <div class="col-xl-5 d-flex col-md-4 col-sm-12">
                  <div>
                    <label class="funds-amount">Select Period</label>
                    <vue-monthly-picker :selectedBackgroundColor="'#E41617'" @selected="getSelected" :clearOption="false" placeHolder="Select Period" dateFormat="MM/YYYY" :monthLabels="monthsLabel" v-model="selectedMonth">
                    </vue-monthly-picker>
                  </div>
                  <!-- <button type="button" class="ml-4 btn btn-custom">Pause plan<img class="ml-2" src="@/assets/TAJimages/pause-icon.png"/></button> -->
                </div>
                <div class="col-xl-7 col-md-8 col-sm-12 mt-3">
                  <div class="account-section" @click="showModal = !showModal">
                    <div>
                      <span class="account-number"><img class="mr-2" src="@/assets/TAJimages/wallet-icon-2.png"/>{{value.accountNumber}}</span>
                      <span class="ml-3 account-name">{{value.accountName}}</span>
                    </div>
                    <div>
                      <span class="account-amount">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(value.availableBalance)}}</span>
                      <span class="ml-3 badge badge-pill badge-custom">Tier {{value.kycLevel}} {{value.accountType}}</span>
                      <span class="ml-2"><img src="@/assets/TAJimages/arrow-down-2.png"/></span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--custom modal -->
            <transition>
                <section class="d-flex justify-content-end mt-4 custom-modal" v-if="showModal">
                    <div class="card shadow-lg" style="border-radius:5px;">
                        <div class="" v-for="account in userAccounts" :key="account.id" @click="selectAccount(account)">
                            <div class="d-flex justify-content-between custom-modal-items">
                                <span>{{account.accountNumber}}</span>
                                <span>{{account.accountName}}</span>
                                <span>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(account.availableBalance)}}</span>
                            </div>
                        </div>
                    </div>
                </section>
            </transition>
            <section class="body-wrapper">
              <h3 class="header-text">Your Savings</h3>
                <div class="row">
                  <div class="col-md-4">
                    <div class="card total-save-card">
                      <div class="card-body" style="padding:30px">
                        <div class="d-flex justify-content-between align-items-center">
                          <h3 class="total-text">Wallet Balance</h3>
                          <h3 class="dot-3">...</h3>
                        </div>
                        <div style="margin-top: 10px;" class="text-center">
                          <img src="@/assets/TAJimages/Safe_perspective_matte 1.png"/>
                          <h3 class="total-amount">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(balanceEnquiry ? balanceEnquiry.balance : 0)}}</h3>
                          <div class="button-section">
                            <button :disabled="balanceEnquiry.balance < 1" type="button" data-toggle="modal" data-target="#withdrawModal" class="btn btn-primary">Withdraw</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-6" v-for="savings in getUserConfigs.length === 0 ? getUserSavings : getUserConfigs" :key="savings.id">
                        <div class="card" style="cursor:pointer;" @click="getSaveSpendDetails(savings)" data-toggle="modal" data-target="#previewSaveSpend">
                          <div class="card-wrapper d-flex align-items-center">
                            <div>
                              <img :src="savings.icon" class="img-fluid" alt="">
                            </div>
                            <div class="ml-3">
                              <h3 class="title-text">{{savings.transactionType === 1 ? 'Funds Transfer' : savings.transactionType === 2 ? 'Bills Payment' : 'Airtime'}}</h3>
                              <div class="row">
                                <div class="col-md-6">
                                  <h4 class="title-subtext">Configuration {{savings.isFlat === true ? 'Amount' : savings.isFlat === false ? 'Percentage' : 'Amount'}}</h4>
                                  <h3 class="funds-amount">{{savings.isFlat===false ? savings.value+'%' : savings.isFlat === true ? new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(savings.value ? savings.value : '0.00') : '₦0.00'}}</h3>
                                </div>
                                <div class="col-md-6 text-right">
                                  <h4 class="title-subtext">Saved</h4>
                                  <h3 class="funds-amount mt-4">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(savings.amountSaved)}}</h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="card">
                          <div class="card-wrapper d-flex align-items-center">
                            <div>
                              <i class="icon fa fa-money"></i>
                            </div>
                            <div class="ml-3">
                              <h3 class="title-text-saved">Total Amount Saved</h3>
                              <h3 class="total-amount-saved text-center">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalAmountSaved)}}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <!--bottom section-->
                <section class="py-5">
                  <div class="row remove-margin container-fluid">
                    <!-- create card -->
                    <div :class="userConfigLength < 1 ? 'col-md-6' : 'col-md-4'" v-if="userConfigLength < 1">
                      <div class="card card-save-wrapper">
                        <div class="row mobile-arrangement">
                          <div class="col-md-6">
                            <h3 class="edit-header-text">Create Configuration</h3>
                            <h4 class="edit-subtext">Change the settings of your savings for this month from the original settings you configured for it to any cofiguration of your choice.</h4>
                            <p class="click-to-edit">Click to create <span><img src="@/assets/TAJimages/arrow-red.png" alt=""></span></p>
                          </div>
                          <div class="col-md-6 text-center">
                            <img src="@/assets/TAJimages/edit-bg-icon.png" class="bg-edit-image img-fluid" alt="">
                            <div class="edit-button">
                              <router-link to="/save-as-you-spend/create" class="edit-link">
                              <button type="button" class="btn btn-success">Create Config</button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--edit card -->
                    <div class="col-md-4" v-if="userConfigLength >= 1">
                      <div class="card card-save-wrapper">
                        <div class="row mobile-arrangement">
                          <div class="col-md-6">
                            <h3 class="edit-header-text">Edit Your Configuration</h3>
                            <h4 class="edit-subtext">Change the settings of your savings for this month from the original settings you configured for it to any cofiguration of your choice.</h4>
                            <p class="click-to-edit">Click to edit <span><img src="@/assets/TAJimages/arrow-red.png" alt=""></span></p>
                          </div>
                          <div class="col-md-6 text-center">
                            <img src="@/assets/TAJimages/edit-bg-icon.png" class="bg-edit-image img-fluid" alt="">
                            <div class="edit-button">
                              <router-link to="edit" class="edit-link">
                              <button type="button" class="btn btn-warning">Edit Config</button>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--delete card -->
                    <div class="col-md-4" v-if="userConfigLength >= 1">
                      <div class="card card-save-wrapper">
                        <div class="row mobile-arrangement">
                          <div class="col-md-6">
                            <h3 class="edit-header-text">Delete Your Configuration</h3>
                            <h4 class="edit-subtext">Erase all your settings for this month’s savings. Reset all to default and start saving afresh.</h4>
                            <p class="click-to-edit">Click to delete <span><img src="@/assets/TAJimages/arrow-red.png" alt=""></span></p>
                          </div>
                          <div class="col-md-6">
                            <img src="@/assets/TAJimages/delete-bg-icon.png" class="bg-edit-image img-fluid" alt="">
                            <div class="edit-button">
                              <button type="button" @click="deleteSaveAsYouSpend" class="btn btn-danger danger-text">Delete Config</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- why save card -->
                    <div :class="userConfigLength < 1 ? 'col-md-6' : 'col-md-4'">
                      <div class="card card-save-wrapper">
                        <div class="row">
                          <div class="col-md-6">
                            <img src="@/assets/TAJimages/why-save-bg.png" class="mt-4 img-fluid" alt="">
                          </div>
                          <div class="col-md-6">
                            <h3 class="edit-header-text-2">Why save?</h3>
                            <h4 class="edit-subtext">First and foremost, saving money is important because it helps protect you in the event of a financial emergency.</h4>
                            <p class="click-to-edit-2"><img src="@/assets/TAJimages/save-icon.png"/> Lean more <span> <img src="@/assets/TAJimages/anchor-right.png" alt=""></span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </section>

            <!--widthraw modal -->
            <div class="modal fade" id="withdrawModal" tabindex="-1" role="dialog" aria-labelledby="withdraw" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title pl-2" id="withdraw" style="font-size: 18px">Withdraw Savings</h5>
                        <button @click="cancelButton" class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                        <div class="modal-body p-4">
                            <section>
                                <div class="mb-3 row">
                                  <label class="col-sm-12 col-form-label" for="Description">Enter Amount <span class="text-danger">*</span></label>
                                  <div class="col-sm-12 col-xl-12">
                                    <input @change="formatInput" @paste.prevent @keypress="isNumber" @keyup="formatWithdrawNum" v-model="form.amount" class="form-control" placeholder="Enter Amount *" required type="text" />
                                  </div>
                                </div>
                                <div class="mb-3 row">
                                  <div class="col-sm-12 col-md-12">
                                  <label class="col-form-label" for="name">Destination Account <span class="text-danger">*</span></label>                             
                                    <select v-model="form.destinationAccountNumber" placeholder="Destination Account *" class="form-control acct-num" required><option value="" disabled>Destination Account *</option>
                                        <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                      </select>
                                  </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-12 col-form-label" for="Purpose">Purpose </label>
                                    <div class="col-sm-12 col-xl-12">
                                        <input v-model="form.description" autocomplete="off" id="no-paste" @click="removeReadonly" class="form-control" placeholder="Why are you withdrawing?" type="text" />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                  <label class="col-sm-12 col-form-label" for="Purpose">Transaction Pin <span class="text-danger">*</span></label>
                                  <div class="col-sm-12 col-xl-12">
                                      <input v-model="form.transactionPin" autocomplete="off" @click="preventAuto" id="prevent-auto" maxlength="4" @paste.prevent @keypress="isNumber" class="form-control" placeholder="Enter PIN" :type="type" required />
                                      <span @click="showPin" class="pull-right show-pin">{{type === 'password' ? 'show' : 'hide'}}</span>
                                  </div>
                                </div>
                            </section>
                            <div class="text-center mt-4">
                              <button type="button" class="btn btn-outline-danger" @click="cancelButton">Close</button>
                              <button class="btn btn-danger ml-3" type="button" @click="withdrawSaveAmount">
                                <div v-if="loader">
                                    <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                  </div>
                                <div v-else>Proceed</div>
                              </button>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- preview save spend details modal -->
            <div class="modal fade" id="previewSaveSpend" tabindex="-1" role="dialog" aria-labelledby="previewSaveSpendTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title pl-2" style="font-size: 20px">Save Spend Details</h5>
                        <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card-content">
                                    <div id="transactionDetailsBody" class="align-content-center align-items-center justify-content-center p-2">
                                        <!-- Budget Details will be loaded here -->
                                        <div class="budget-header-wrapper">
                                          <h5 class="text-center mb-4 text-dark">{{previewDetails.transactionType === 1 ? 'Funds Transfer' : previewDetails.transactionType === 2 ? 'Bills Payment' : 'Airtime'}}</h5>
                                          <div class="budget-icon text-center">
                                            <div class="icon-wrapper mb-3">
                                              <img :src="previewDetails.icon" class="img-fluid" alt="">
                                            </div>
                                            <p class="text-dark">{{previewDetails.transactions.length === 0 ? 'No' : previewDetails.transactions.length}} {{previewDetails.transactions.length > 1 ? 'Transactions' : 'Transaction'}}</p>
                                            <div>
                                              <span class="text-dark mt-4">Total Amount Saved</span>
                                              <h5 class="mt-2 text-dark font-weight-bold">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(previewDetails.amountSaved)}}</h5>
                                            </div>
                                          </div>
                                        </div>
                                        <table class="table views-table table-striped">
                                          <tbody>
                                            <tr class="transaction-table" v-for="transaction in previewDetails.transactions" :key="transaction.id">
                                              <td>Date <span class="font-weight-bold"><br>{{transaction.createdDate | moment}}</span></td>
                                              <td>Description<span class="font-weight-bold"><br>Transaction to {{transaction.label}}</span></td>
                                              <td>Transaction Amount<span class="font-weight-bold"><br>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(transaction.transactionAmount)}}</span></td>
                                              <td>Amount Saved<span class="font-weight-bold"><br>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(transaction.amount)}}</span></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import VueMonthlyPicker from 'vue-monthly-picker';
  import moment from 'moment';
  import $ from 'jquery';
  import { decrypt } from '@/_services/encryption';
  // import comingSoon from '@/components/coming-soon.vue';
  export default {
    components: {
      // comingSoon,
      VueMonthlyPicker
    },
    filters: {
      moment: function (date) {
        return moment(date).format('Do MMMM, YYYY');
      }
    },
    data:() => ({
      showModal: false,
      type: 'password',
      accountNumber: '',
      form: {
        destinationAccountNumber: '',
        description: '',
        amount: '0.00',
        transactionPin: '',
        platform: 1,
        transactionReference: '',
      },
      previewDetails: {
        transactionType: '',
        transactions: [],
        icon: '',
        value: '',
        isFlat: false,
        amountSaved: '',
      },
      loading: false,
      loader: false,
      totalAmountSaved: '0.00',
      value: {},
      format: 'yyyy-MM-dd',
      selectedMonth: '',
      monthsLabel: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      isSwitched: 'currentMonth',
      configCategoriesIcons: [
        { icon: require('@/assets/TAJimages/funds-icon.png') },
        { icon: require('@/assets/TAJimages/bills-icon.png') },
        { icon: require('@/assets/TAJimages/airtime-icon.png') },
      ],
      configCategories: [
        { id: 1, name: 'Funds Transfer', value: 0, amountSaved: 0, icon: require('@/assets/TAJimages/funds-icon.png'), isFlat: true, transactionType: 1, status: 1, },
        { id: 2, name: 'Bills Payment', value: 0, amountSaved: 0, icon: require('@/assets/TAJimages/bills-icon.png'), isFlat: true, transactionType: 2, status: 1, },
        { id: 3, name: 'Airtime', value: 0, amountSaved: 0, icon: require('@/assets/TAJimages/airtime-icon.png'), isFlat: true, transactionType: 3, status: 1, },
      ],
    }),
    computed: {
      ...mapState({
        account: state => state.dashboard.dashboardData,
        getUserSaveAsYouSpend: state => state.saveAsYouSpend.getUserSaveAsYouSpend,
        getUserSaveAsYouSpendHistory: state => state.saveAsYouSpend.getUserSaveAsYouSpendHistory,
        balanceEnquiry: state => state.saveAsYouSpend.balanceEnquiry,
      }),
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      getFirstAccount() {
        return this.userAccounts[0];
      },
      routeName() {
        return this.$route.name;
      },
      getUserSavings() {
        return this.getUserSaveAsYouSpendHistory ? this.getUserSaveAsYouSpendHistory.savings : [];
      },
      configs() {
        return this.getUserSaveAsYouSpendHistory ? this.getUserSaveAsYouSpendHistory.configs : [];
      },
      getUserConfigs() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.configs ? this.configs.sort((a, b) => a.transactionType - b.transactionType) : [];
      },
      userConfigLength() {
        return this.getUserConfigs ? this.getUserConfigs.length : 0;
      }
    },
    mounted() {
      this.$store.dispatch('saveAsYouSpend/getBalanceEnquiry');
      this.loading = true;
      this.$store.dispatch('dashboard/getDashboardData').then(response => {
        if(response.status === 200) {
          this.loading = false;
          this.$store.dispatch('saveAsYouSpend/getSaveAsYouSpend', this.getFirstAccount.accountNumber);
          this.value = this.getFirstAccount;
          this.accountNumber = this.getFirstAccount.accountNumber;
          // fetch configs
          const dateObj = new Date();
          let firstDay = new Date(dateObj.getFullYear(), dateObj.getMonth(), 1);
          this.selectedMonth = moment(firstDay).format('YYYY-MM-DD');
          this.form.period = this.selectedMonth;
          const data = {
            accountNumber: this.getFirstAccount.accountNumber,
            period: moment(firstDay).format('YYYY-MM-DD'),
          };
          this.fetchConfigurations(data);
        }
      });
    },
    methods: {
      formatInput(event) {
        this.form.amount = event.target.value;
        const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
        this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
      },
      formatWithdrawNum(event) {
        if(this.form.amount === '') {
          this.form.amount = '0.00';
        } else {
          this.form.amount = event.target.value;
          const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
          this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        }
        if(event.key === 'Backspace' || event.key === 'Delete') {
          if(event.target.value.length <= 4) {
            const formatter = new Intl.NumberFormat('en-US');
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.target.value.length < 2) {
              this.form.amount = '0.00';
            }
          } else {
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            return;
          }
        }	
      },
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      preventAuto(){
        document.getElementById('prevent-auto').removeAttribute('readonly');
      },
      getSaveSpendDetails(details) {
        this.previewDetails = details;
      },
      selectAccount(account) {
        this.value = account;
        this.showModal = false;
        this.accountNumber = account.accountNumber;
        // fetch configs
        const data = {
          accountNumber: this.accountNumber,
          period: this.form.period,
        };
        this.fetchConfigurations(data);
      },
      getSelected(month){
        const monthInfo = month._d;
        let monthMoment = moment(monthInfo).format('YYYY-MM-DD');
        this.form.period = monthMoment;
        const data = {
          accountNumber: this.accountNumber,
          period: this.form.period,
        };
        this.fetchConfigurations(data);
      },
      // fetch configurations function
      fetchConfigurations(data) {
        this.loading = true;
        this.$store.dispatch('saveAsYouSpend/getSaveAsYouSpendHistory', { data }).then((response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          if(response.status === 200) {
            this.loading = false;
            // total config amount
            this.totalAmountSaved = userParseData.savings.reduce((acc, curr) => {
              return acc + curr.amountSaved;
            }, 0);
            // filter configs
            const savings = this.getUserSavings.map((item, index) => index);
            const configs = this.getUserConfigs.map((item, index) => index);
            const icons = this.configCategoriesIcons.map((item, index) => index);
            configs.forEach(item => {
              return savings.map((value, index)=> {
                if(item === index) {
                  this.getUserConfigs[value].amountSaved = this.getUserSavings[item].amountSaved;
                  this.getUserConfigs[item].transactions = this.getUserSavings[value].transactions;
                }
              });
            });
            configs.forEach(item => {
              return icons.map((value, index)=> {
                if(item === index) {
                  this.getUserConfigs[item].icon = this.configCategoriesIcons[value].icon;
                }
              });
            });
          }
        }).catch(error => {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.loading = false;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: objError.errors[0],
          });
        });
      },
      // delete save as you spend
      deleteSaveAsYouSpend() {
        this.$swal({
          title: 'Are you sure?',
          text: `You want to delete configuration for this account (${this.value.accountNumber} - ${this.value.accountName})?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'btn btn-primary',
          confirmButtonClass: 'btn btn-success mr-2',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.loading = true;
            this.$store.dispatch('saveAsYouSpend/deleteSaveAsYouSpend', this.value.accountNumber).then((response) => {
              if (response.status === 200) {
                this.loading = false;
                this.$swal({
                  title:'Success',
                  text: 'Configuration Deleted successfully',
                  type:'success',
                  confirmButtonText: 'OK'
                }).then(() => {
                  // this.$store.dispatch('saveAsYouSpend/getSaveAsYouSpendHistory');
                  window.location.reload();
                });
              }
            }).catch((error) => {
              const decryptedError = decrypt(error.response.data);
              const objError = JSON.parse(decryptedError);
              this.loading = false;
              this.$swal({
                title:'Oops...',
                text: objError.errors[0],
                type:'error'
              });
            });
          }
        });
      },
      generateUUID() {
        // generate unique id
        var d = new Date().getTime();
        var uuid = 'xxxxxx-xxxx-4xxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (d + Math.random()*16)%16 | 0;
          d = Math.floor(d/16);
          return (c==='x' ? r : (r&0x3|0x8)).toString(16);
        });
        this.form.transactionReference = uuid;
        return uuid;
      },
      withdrawSaveAmount() {
        if(this.form.amount === '0.00' || this.form.destinationAccountNumber === '' || this.form.transactionPin === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Please fill all the fields',
          });
        } else {
          this.generateUUID();
          const data = {
            amount: Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
            destinationAccountNumber: this.form.destinationAccountNumber,
            transactionReference: this.form.transactionReference,
            description: this.form.description,
            transactionPin: this.form.transactionPin,
            platform: 1,
          };
          this.loader = true;
          this.$store.dispatch('saveAsYouSpend/withdrawFromWallet', data).then((response) => {
            if (response.data.responseCode !== '00') {
              this.loader = false;
              $('#withdrawModal').modal('hide');
              this.$swal({
                title:'Oops...',
                text:response.data.responseDescription,
                type:'error'
              }).then(() => {
                $('#withdrawModal').modal('show');
              });
              return;
            } else {
              $('#withdrawModal').modal('hide');
              this.loader = false;
              this.$swal({
                title:'Success',
                text: 'Withdrawal Successful',
                type:'success',
                confirmButtonText: 'OK'
              }).then(() => {
                window.location.reload();
              });
            }
          }).catch((error) => {
            $('#withdrawModal').modal('hide');
            this.loader = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error'
            }).then(() => {
              $('#withdrawModal').modal('show');
            });
          });
        }
      },
      cancelButton() {
        $('#withdrawModal').modal('hide');
        this.form.amount = '0.00';
        this.form.description = '';
        this.form.destinationAccountNumber = '';
        this.form.transactionPin = '';
        this.form.transactionReference = '';
      }
    }
  };
</script>
<style scoped>
.btn-custom {
  background: #fff;
  border-radius: 5px;
  padding: 8px 20px;
  /* height: 40px; */
}
.vue-monthly-picker .input {
  height: 55px !important;
}
.prev-btn {
  background: #fdfdfe;;
}
.active-state {
  background: #E41512;
  color: #fff;
}
.active-state:hover {
  color: #fff;
}
.group-btn {
  width: 100%;
}
.account-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  padding: 13px 20px;
  align-items: center;
  /* margin-left: 40px; */
  cursor: pointer;
  flex-direction: row;
}
.badge-custom {
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: #5B93FF80;
  background: #5B93FF10;
  opacity: 1;
}
.header-text {
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  color: #030229;
  opacity: 0.7;
  padding: 40px 0px 20px 0px;
  text-align: center;
}
.total-save-card {
  background-image: url(../../assets/TAJimages/bg-total-save.png);
  background-size: cover;
  height: 335px;
}
.total-text {
  font-weight: 800;
  font-size: 18px;
  line-height: 25px;
  color: #030229;
  opacity: 0.7
}
.dot-3 {
  font-size: 26px;
  color: #030229
}
.total-amount {
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
  color: #030229;
  opacity: 0.7;
  margin-top: 23px;
  margin-bottom: 35px;
}
.card-wrapper {
  padding: 20px;
}
.title-text {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
  letter-spacing: 0;
  opacity: 0.7;
}
.title-text-saved {
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0;
  color: #000000;
  opacity: 0.7;
  padding-top: 12px;
}
.total-amount-saved {
  font-weight: 800;
  font-size: 30px;
  line-height: 30px;
  color: #030229;
  opacity: 0.7;
  padding-bottom: 20px;
  padding-top: 5px;
}
.title-subtext {
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #030229;
  opacity: 0.7;
  letter-spacing: 0;
}
.funds-amount {
  font-weight: 800;
  font-size: 15px;
  line-height: 20px;
  color: #000000;
  opacity: 0.7;
  letter-spacing: 0;
}
.card-save-wrapper {
  padding: 18px;
  height: 90%;
}
.bg-edit-image {
  padding-top: 60px !important;
}
.edit-header-text {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
  opacity: 0.7;
  padding-bottom: 20px;
}
.edit-header-text-2 {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
  opacity: 0.7;
  padding: 20px 0px 15px 0px;
}
.edit-subtext {
  font-weight: 300;
  font-size: 12px;
  line-height: 140%;
  color: #4F4E69;
}
.click-to-edit {
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: #E41512;
  padding-top: 32px;
}
.click-to-edit-2 {
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: #E41512;
  padding-top: 20px;
}
.edit-button {
  text-align: center;
  margin-top: -40px;
}
.btn-warning, 
.danger-text, 
.btn-success {
  padding: 5px 20px;
  font-size: 12px;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.custom-modal {
  position: absolute;
  z-index: 1;
  right: 20px;
  /* opacity: 1; */
  transition: all 1s;
}
.custom-modal-items {
  cursor: pointer;
  padding: 10px 15px;
}
.shadow-lg {
  width: 500px
}
.custom-modal-items:hover {
  background: #E41617;
  color: #fff;
  /* padding: 10px; */
  transition: all 0.5s ease;
  border-radius: 5px;
}
.icon {
  font-size: 25px;
  width: 65px;
  padding: 20px;
  border-radius: 50px;
  color: #E41617;
  background: #FFF4F290;
}
@media screen and (max-width: 768px) {
  .mobile-arrangement {
    display: flex;
    flex-direction: column-reverse;
  }
  .bg-edit-image {
    padding-top: 10px !important;
  }
  .edit-header-text {
    padding-top: 30px;
  }
  .remove-margin {
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .shadow-lg {
    width: 100%
  }
  .account-section {
    flex-direction: column;
  }
}
</style>